import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { PricingClient } from 'src/WebApiController';

export function useGetSectionRowScoreRecommendations(
  eventId?: number,
  venueConfigId?: number,
  rowId?: number,
  disabled?: boolean
) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();

  const shouldQuery = useMemo(
    () => Boolean(eventId && venueConfigId && rowId) && !disabled,
    [disabled, eventId, rowId, venueConfigId]
  );
  const scoreRecommendationQuery = useQuery({
    queryKey: ['getSalesByEventId', eventId, venueConfigId, rowId, disabled],
    async queryFn() {
      if (!shouldQuery) return null;

      return await new PricingClient(
        activeAccountWebClientConfig
      ).getScoreSectionRecommendationsByRow(eventId, venueConfigId, rowId);
    },
    enabled: shouldQuery,
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('PricingClient.getScoreSectionRecommendationsByRow', error);
      },
    },
  });

  return {
    selectedSectionRecommendations: scoreRecommendationQuery.data ?? undefined,
    isLoading: scoreRecommendationQuery.isPending,
  };
}
